class Pool {
  constructor(size, factory) {
    this.size = size;
    this.factory = factory;
    this.queue = [];
    this.working = [];
    this.completed = [];
  }

  schedule(item) {
    this.queue.push(item);
    this.next();
  }

  next() {
    if (
      this.queue.length &&
      this.working.length - this.completed.length < this.size
    ) {
      const item = this.queue.pop();

      const promise = this.factory(item);

      this.working.push(item);

      promise.then(() => {
        this.completed.push(item);
        this.next();
      });
    }
  }
}

export default Pool;
